import { render, staticRenderFns } from "./aRoomFeeCallable.vue?vue&type=template&id=a4cbe324&scoped=true"
import script from "./aRoomFeeCallable.vue?vue&type=script&lang=js"
export * from "./aRoomFeeCallable.vue?vue&type=script&lang=js"
import style0 from "./aRoomFeeCallable.vue?vue&type=style&index=0&id=a4cbe324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cbe324",
  null
  
)

export default component.exports